const contentIconsMixin = {
    computed: {
        contentIcons() {
            return [
                'accept',
                'add',
                'add-circle',
                'admin',
                'aladdin',
                'arr_1down',
                'arr_1left',
                'arr_1right',
                'arr_1up',
                'arr_2down',
                'arr_2left',
                'arr_2right',
                'arr_2up',
                'audio',
                'audio3',
                'billboard',
                'block-canvas',
                'block-comparison',
                'block-eyecatcher',
                'block-gallery',
                'block-gallery2',
                'block-imagemap',
                'brainstorm',
                'campusnavi',
                'chat2',
                'code',
                'community2',
                'computer',
                'consultation',
                'content',
                'courseware',
                'crown',
                'date-single',
                'decline',
                'decline-circle',
                'doctoral_cap',
                'download',
                'dropbox',
                'edit',
                'exclaim',
                'exclaim-circle',
                'export',
                'favorite',
                'filter',
                'globe',
                'graph',
                'group2',
                'group3',
                'group4',
                'home',
                'home2',
                'info',
                'info-circle',
                'install',
                'institute',
                'key',
                'knife',
                'learnmodule',
                'lightbulb',
                'lightbulb2',
                'link2',
                'link3',
                'link-extern',
                'link-intern',
                'literature',
                'lock-locked',
                'lock-unlocked',
                'mail2',
                'medal',
                'metro',
                'microphone',
                'module',
                'network',
                'network2',
                'notification',
                'notification2',
                'opencast',
                'outer-space',
                'permalink',
                'person',
                'phone',
                'picture',
                'place',
                'plugin',
                'question',
                'question-circle',
                'ranking',
                'remove',
                'remove-circle',
                'resources',
                'roles',
                'schedule2',
                'search',
                'settings',
                'span-empty',
                'span-1quarter',
                'span-2quarter',
                'span-3quarter',
                'span-full',
                'spiral',
                'sport',
                'staple',
                'star',
                'star-empty',
                'star-halffull',
                'test',
                'tools',
                'topic',
                'ufo',
                'video2',
                'visibility-visible',
                'wizard',
            ];
        },
    },
};

export default contentIconsMixin;
